<div class="container-fluid">
  <div style="height: 5%;">
    <h2 class="title-center">Base Endpoint Mappings Report</h2>
  </div>
  <ng-container>

    <div class="report-filter-cards">
      <div class="row row-cols-1 row-cols-md-2 row-cols-sm-2 g-4 pb-1">

        <div class="col">
          <div class="card h-100">
            <div class="card-body">
              <div class="card-title">Destination Endpoints</div>
              <div class="example-wrapper">
                <app-lt-multiselect-t
                  [data]="destinationEndpointItems"
                  textField="displayName"
                  valueField="destinationEndpointId"
                  placeholder="Select Destination Endpoint..."
                  (selectionChange)="externalFilterChange()"
                [(ngModel)]="destinationEndpointItemsSelected"></app-lt-multiselect-t>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card h-100">
            <div class="card-body">
              <div class="card-title">Import Type:</div>
              <div class="example-wrapper">
                <app-lt-multiselect-t
                  [data]="importTypeItems"
                  textField="typeDescription"
                  valueField="importTypeId"
                  placeholder="Select Import Type..."
                  (selectionChange)="externalFilterChange()"
                [(ngModel)]="importTypeItemsSelected"></app-lt-multiselect-t>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container>
      <hr class="hr-solid">
      <div class="row row-cols-1 row-cols-md-2 row-cols-sm-2 pb-3 g-3">
          <div class="col">
              <div class="card search-card h-100">
                  <div class="card-body">
                      <div class="input-group">
                          <mat-form-field class="w-100">
                              <mat-label>{{xmlSearchTerm.defaultText}}</mat-label>
                              <input type="text" class="form-control" matInput [(ngModel)]="xmlSearchTerm.searchValue">
                              <button matIconButton matSuffix (click)="updateSearch(xmlSearchTerm)" class="px-1 search-icon-btn">
                                  <mat-icon class="material-icons-outlined search-icon">search</mat-icon>
                              </button>
                              <button matIconButton matSuffix (click)="clearSearch(xmlSearchTerm)" class="px-1 search-icon-btn">
                                  <mat-icon class="material-icons-outlined search-icon">close</mat-icon>
                              </button>
                          </mat-form-field>
                      </div>

          </div>
          @if (xmlSearchTerm.hasSearchTerm) {
            <div class="card-footer card-current-search">
              Current Search: {{xmlSearchTerm.currentSearchValue | json}}
            </div>
          }
        </div>
      </div>

      <div class="col">
        <div class="card search-card h-100">
          <div class="card-body">
            <div class="input-group">
              <mat-form-field class="w-100">
                <mat-label>{{jsSearchTerm.defaultText}}</mat-label>
                <input type="text" class="form-control integJSSearchBox" matInput [(ngModel)]="jsSearchTerm.searchValue">
                <button mat-icon-button matSuffix (click)="updateSearch(jsSearchTerm)" class="px-1 search-icon-btn">
                  <mat-icon class="material-icons-outlined search-icon">search</mat-icon>
                </button>
                <button mat-icon-button matSuffix (click)="clearSearch(jsSearchTerm)" class="px-1 search-icon-btn">
                  <mat-icon class="material-icons-outlined search-icon">close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          @if (jsSearchTerm.hasSearchTerm) {
            <div class="card-footer card-current-search">
              Current Search: {{jsSearchTerm.currentSearchValue | json}}
            </div>
          }
        </div>
      </div>
    </div>
  </ng-container>

  <div class="report-command-button-group">
    <button type="button" class="btn btn-outline-secondary" (click)="resetFilters()">
      Reset Filters
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="applyFilters()" >
      Apply Filters
    </button>
  </div>

  <hr class="hr-solid">

  @if (showMappingContainer) {
    @if (haveMappings) {
      @if (currMappingType === mappingType.BaseEndpointMapping) {
        <app-lt-generic-grid-wrapper #viewGenericGrid
          [data]="filteredBaseEndpointMappingData"
          [columns]="reportColumns"
          [exportFileName]="'Mappings-Report.xlsx'"
          [isResizeable]="true"
          [showExportToolbar]="true"
          [isSelectable]="false"
          [showSelectionColumn]="false"
          [showChangeSelection]="false"
          [selectionfield]="'baseEndpointMappingId'"
          [hasActionGoToColumn]="true"
          [actionGoToUsePrefix]="false"
          [actionGoToField]="'routerUrl'"
          [loading]="gettingMappings">
        </app-lt-generic-grid-wrapper>
      }
    }
    @else {
      <div style="margin: auto; text-align: center;">
        @if(gettingMappings){
          <div>
            <app-lt-spinner></app-lt-spinner>
          </div>
        } @else {
          <p>No Mappings Returned for Report Query.</p>
        }
      </div>
    }
  }
</div>
